import React from "react";
import { Card, Col, Row } from "reactstrap";
import useCurrentSaleStore from "stores/SaleStore";
import shallow from "zustand/shallow";
import DealBuyerSwitchButton from "features/deal/components/DealBuyerSwitchButton";
import DealWholesaleInvsList from "../wholesaleInventorys/DealWholesaleInvsList";
import BulkSale from "../../sale/BulkSale";
import DealInformation from "./DealInformation";

/**
 * Component for displaying the content of a deal, including buyer info, deal details, and related sections.
 *
 * @component
 * @returns {JSX.Element} The rendered component.
 */
export const BullkWholesaleTab = () => {
	// State from sale store
	const { saleType } = useCurrentSaleStore(
		(state) => ({
			saleType: state.saleType,
		}),
		shallow
	);

	return (
		<>
			<Row className="d-flex align-items-start">
				<Col lg="4" className="text-center mb-2-sm">
					<Card className="h-100 card-plain mt-0">
						<div className="p-0 d-flex flex-column">
							<DealBuyerSwitchButton saleType={saleType} />
						</div>
					</Card>
				</Col>
				<Col lg="4">
					<Card>
						<BulkSale />
					</Card>
				</Col>

				<Col lg="4">
					<DealInformation />
				</Col>
			</Row>

			<hr className="my-3 mx-3" />
			<Col lg="12">
				<Card className="h-100 card-plain mt-0 mb-2-sm">
					<div>
						<DealWholesaleInvsList />
					</div>
				</Card>
			</Col>
		</>
	);
};

export default BullkWholesaleTab;
